import React, {useEffect, useContext, useState} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  const [durationOptions, setDurationOptions] = useState([])
  const [displayFormatOptions, setDisplayFormatOptions] = useState([
    {name: 'DD:HH:MM:SS', value: 'days_hours_minutes_seconds'},
    {name: 'HH:MM:SS', value: 'hours_minutes_seconds'},
  ])
  useEffect(() => {
    getAdditionalFieldValues(group_id, ['DateField', 'DateTimeField'], true, false, false)
  }, [group_id, getAdditionalFieldValues])

  useEffect(() => {
    if (
      additionalFieldValues.data?.data?.fields &&
      Array.isArray(additionalFieldValues.data?.data?.fields)
    ) {
      let fields = additionalFieldValues.data?.data?.fields.map(f => {
        return {
          name: f.name,
          value: {id: f.id, key: f.key},
        }
      })
      setDurationOptions([{name: 'Current Date', value: {id: 'date_today', key: null}}, ...fields])
    }
  }, [additionalFieldValues])
  return (
    <>
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e =>
              onChange(e, 'time_based_calculation', !(data?.time_based_calculation || false))
            }
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.time_based_calculation || false}
            name="required"
          />
        }
        label="Time based calculation"
      />
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Duration between</InputLabel>
        <Select
          labelId=""
          id=""
          value={data.duration_start}
          label="Duration between"
          onChange={(e, value) => onChange(e, 'duration_start')}
          style={{width: '200px'}}
        >
          {durationOptions.map(opt => {
            return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">and</InputLabel>
        <Select
          labelId=""
          id=""
          value={data.duration_end}
          label="and"
          onChange={(e, value) => onChange(e, 'duration_end')}
          style={{width: '200px'}}
        >
          {durationOptions.map(opt => {
            return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      {data?.time_based_calculation && (
        <FormControl
          variant="outlined"
          className="ap-textfield"
          style={{width: 200, marginTop: 16}}
        >
          <InputLabel id="">Display format</InputLabel>
          <Select
            labelId=""
            id=""
            value={data.display_format}
            label="Display format"
            onChange={(e, value) => onChange(e, 'display_format')}
            style={{width: '200px'}}
          >
            {displayFormatOptions.map(opt => {
              return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
            })}
          </Select>
        </FormControl>
      )}
    </>
  )
}

export default FTextField
